import jwt from "../../http/requests/auth/jwt"
import authService from "@/auth/authService"

import router from "@/router"

export default {

  loginJWT({ commit }, payload) {

    return new Promise((resolve, reject) => {
      jwt.login(payload.userDetails.email, payload.userDetails.password)
        .then(response => {
          if (response.data) {
            authService.localLogin(commit, response.data)
            router.push(router.currentRoute.query.to || "/")

            resolve(response)
          } else {
            reject({ message: "Wrong Email or Password" })
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updatePassword ({ commit }, payload) {
    return jwt.post("/api/account/updatepassword", payload)
  },
  resetPassword ({ commit }, payload) {
    return jwt.post("/api/account/forgotpassword", { email: payload.email, resetMethod: "Code" })
  },
  registerUserJWT({ commit }, payload) {

    const { displayName, email, password, confirmPassword } = payload.userDetails

    return new Promise((resolve, reject) => {

      // Check confirm password
      if (password !== confirmPassword) {
        reject({ message: "Password doesn\"t match. Please try again." })
      }

      jwt.registerUser(displayName, email, password)
        .then(response => {
          // Redirect User
          router.push(router.currentRoute.query.to || "/")

          // Update data in localStorage
          localStorage.setItem("accessToken", response.data.bearerToken)
          localStorage.setItem("refreshToken", response.data.refreshToken)
          commit("UPDATE_USER_INFO", response.data.userData, { root: true })

          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchProfile ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      jwt.get("/api/account/profile")
        .then((response) => {
          const profile = response.data.profile
          let isSystemAdmin = false
          if (profile.roles && profile.roles.length === 1 && profile.roles[0] === "admin") {
            isSystemAdmin = true
          }
          commit("UPDATE_USER_INFO", {
            about: "",
            displayName: profile.displayName,
            email: profile.email,
            photoUrl: profile.profileUrl,
            status: "online",
            uid: profile.id,
            isSystemAdmin: isSystemAdmin
          }, { root: true })
          commit("UPDATE_USER_ORGANISATIONS", {
            organisations: response.data.organisations
          }, { root: true })
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateProfile ({ commit }, updatedData) {
    return new Promise((resolve, reject) => {
      jwt.get(`/api/account/profile`)
        .then((response) => {
          const data = response.data.profile
          Object.assign(data, updatedData)
          jwt.post('/api/account/update', data)
            .then((response) => {
              const profile = response.data.profile
              commit("UPDATE_USER_INFO", {
                displayName: profile.displayName,
                email: profile.email,
                photoUrl: profile.profileUrl
              }, { root: true })
              resolve(response)
            })
            .catch((error) => { reject(error) })
        }).catch((error) => { reject(error) })
    })
  },
  fetchOrganisations ({ commit }) {
    return new Promise((resolve, reject) => {
      jwt.get("/api/organisation/list")
        .then((response) => {
          commit("UPDATE_USER_ORGANISATIONS", {
            organisations: response.data.items
          }, { root: true })
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAccessToken() {
    return new Promise((resolve) => {
      jwt.refreshToken()
        .then(response => {
          localStorage.setItem("accessToken", response.data.accessToken)
          if (response.data.refreshToken) {
            localStorage.setItem("refreshToken", response.data.refreshToken)
          }
          resolve(response.data.accessToken)
        })
        .catch(error => {
          console.warn(`Error fetching accessToken => ${error}`)
          localStorage.removeItem("accessToken")
          localStorage.removeItem("refreshToken")
          localStorage.removeItem("loggedIn")
          router.push({ path: "/login", query: { to: router.currentRoute.path } })
        })
    })
  }
}
